// No credential crosses postMessage. The private proof and returned account
// tokens stay inside Gab's web origin, with the normal web auth store.
export function browserPanelGuest(state) {
  return state._hasHydrated && !state._isSigningOut && (!state.token || !state.user?.id || state.user?.flags?.isGhost);
}
export async function signInBrowserPanel({ getState, request, send, current, crypto = globalThis.crypto, wait = ms => new Promise(resolve => setTimeout(resolve, ms)) }) {
  const initial = getState();
  if (!browserPanelGuest(initial)) return false;
  const generation = initial._sessionGeneration;
  const valid = () => current() && browserPanelGuest(getState()) && getState()._sessionGeneration === generation;
  const base64url = bytes => btoa(String.fromCharCode(...bytes)).replaceAll('+', '-').replaceAll('/', '_').replaceAll('=', '');
  const verifier = base64url(crypto.getRandomValues(new Uint8Array(32)));
  const challenge = base64url(new Uint8Array(await crypto.subtle.digest('SHA-256', new TextEncoder().encode(verifier))));
  if (!valid()) return false;
  const started = await request('start', { challenge });
  if (!valid()) return false;
  if (!/^[A-Za-z0-9_-]{43}$/.test(started?.id || '')) throw new Error('Invalid Mac sign-in request.');
  send('mac-sign-in', { id: started.id });
  for (let attempt = 0; attempt < 20; attempt++) {
    await wait(1000);
    if (!valid()) return false;
    const result = await request('complete', { id: started.id, verifier });
    if (!valid()) return false;
    if (result?.pending) continue;
    if (!result?.tokens?.access || !result.tokens.refresh || !result.user?.id || result.user.flags?.isGhost) throw new Error('Invalid Mac sign-in response.');
    getState().setAuthData(result.tokens.access, result.tokens.expiresAt, result.tokens.refresh, result.user);
    send('mac-sign-in-complete');
    return true;
  }
  throw new Error('Mac sign-in timed out.');
}
